import { Autocomplete, Chip, TextField } from '@mui/material';
import React, { useState } from 'react';
import { useEffect } from 'react';

const ChipInput = ({onChange, value, label, variant, onDelete, onAdd, placeholder, sx, sxTextField, sxChip}) => {

    /* 
        Chip input modified to allow usage of space bar, comma, as well as return button
        Had to roll my own as MUI5 doesnt seem to have one anymore


    */

    const [values, setValues] = useState([]);
    const [lastValues, setlastValues] = useState([]);
    const [inputValue, setInputValue] = useState('');


    useEffect(()=>{

        setValues(value);

    }, []);

    useEffect(()=>{

        //call callback when values change
        if(typeof onValueChange === 'function'){

            onChange(values);
        }

        if(typeof onDelete === 'function' && lastValues.length > values.length){

            //get deleted value from lastValues
            var deletedValue = lastValues.filter((value) => !values.includes(value))[0];
            onDelete(deletedValue, values);

        }

        if(typeof onAdd === 'function' && lastValues.length < values.length){

            //get last added value
            var addedValue = values[values.length -1];
            onAdd(addedValue, values);

        }

        //set last values
        if(values !== lastValues){
            setlastValues(values);
        }
        

    }, [values]);

    const handleChange = (value) => {

        setValues((prevValues)=>{

            return value;
        });

    }

    const renderTags = (value, getTagProps) => {

        return value.map((option, index) => {

            return (
                <Chip 

                    key={'chip'+index}
                    variant= {variant}
                    label={option}
                    sx={{...sxChip}}
                    {...getTagProps({index})}
                
                />
            );
        });
    }

    const renderInput = (params) => {

        if(params.value?.replace(/\s/g, '').length === 0){
            params.value= ''; 
        }

        return (
            <TextField 
            
                {...params}
                variant='standard'
                label={label}
                placeholder={placeholder}
                value={inputValue}
                onChange={handleInputChange}
                sx={{...sxTextField }}
                
            />
        );
    }

    const handleKeyUp = (event) => {

        //if keyup is space, execute on change
        let keyCode = event.keyCode
        if(keyCode === 32 || keyCode === 13 || keyCode === 188 || keyCode === 186){

            //get value
            let value = event.target.value.trim();
            value = value.replace(/\s+$/, '');

            if(value.length === 0 || value.replace(/\s/g, '').length === 0){

                return; 
            }
            
            //force an enter
            setValues((prevValues) => {
                return [...prevValues, value]; //.push(value);
            });

            //remove input value from input
            setInputValue('');

        }
    }

    const handleInputChange = (event) => {

        setInputValue(event.target.value);

    }

    return (
        <Autocomplete

            multiple
            options={[]}
            defaultValue={[]}
            freeSolo
            value= {values}
            inputValue={inputValue}
            onKeyDown={handleKeyUp}
            sx={{...sx }}
            onChange={(event, value)=> {
                
                var input = event.target.value;
                if(input?.length === 0 || input?.replace(/\s/g, '').length === 0){
                    //string is just white space
                    return; 
                }
                handleChange(value)
            }}
            renderTags={renderTags}
            renderInput={renderInput}
        
        />
    );
}

export default ChipInput; 